import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

const DEFAULT_MAX_TOKENS = 1200;
export const MOOD_VALUES = ["casual", "professional", "confident", "friendly"] as const;

export type Mood = (typeof MOOD_VALUES)[number];
export type Action = "improve" | "fix" | "tone";

const textSchema = z.object({
  text: z
    .string({
      required_error: "Text is required",
      invalid_type_error: "Text must be a string",
    })
    .min(1, "Text cannot be empty")
    .max(DEFAULT_MAX_TOKENS, `Text max length is ${DEFAULT_MAX_TOKENS}`),
});

const changeToneSchema = textSchema.extend({
  mood: z.enum(MOOD_VALUES, {
    required_error: "Mood is required",
    invalid_type_error: "Mood must be one of: casual, professional, confident, friendly",
  }),
});

export class TextDto extends createZodDto(textSchema) {}
export class ChangeToneDto extends createZodDto(changeToneSchema) {}
